import { createNamedStyles } from "../../../shared/CreateNamedStyles";

export const SectionBodyStyles = createNamedStyles({
  root: {
    margin: 0,
  },
});
